export default __webpack_public_path__ + "static/media/Angels.86ff5060.png";